import i18n from 'src/i18n/index.js';
import Gender from 'src/models/gender.js';

class Message {
  constructor(data) {
    if (!data) return undefined;

    this.createdAt = data.createdAt;

    this.customerInitials = data.customerInitials;
    this.customerLastName = data.customerLastName;
    this.customerBirthDate = data.customerBirthDate;
    this.customerNumber = parseInt(data.customerNumber);
    this.customerGender = new Gender(data.customerGender);
    this.fullName = `${this.customerInitials} ${this.customerLastName}`;
    this.fullNameWithSalutation = `${i18n.global.t(`gender.salutation-${data.customerGender.toLowerCase()}`)}
      ${this.customerInitials} ${this.customerLastName}`;
    this.fullNameWithShortHandSalutation = `${i18n.global.t(`gender.short-hand-salutation-${data.customerGender.toLowerCase()}`)}
      ${this.customerInitials} ${this.customerLastName}`;

    this.docType = data.docType;
    this.docTypeID = data.docTypeID;

    this.documentCluster = data.documentCluster;
    this.documentID = data.documentID;
    this.documentName = data.documentName;
    this.extension = data.extension;
    this.hasBeenRead = data.hasBeenRead;
    this.label = data.label;
    this.name = data.name;
    this.nameObject = this.getNameObject(data.name);
    this.policyNumber = data.policyNumber;
    this.productType = data.productType;
    this.publicationDate = data.publicationDate;

    this.contractCode = data.contractCode;
    this.guidName = data.guidName;

    return this;
  }

  getNameObject(name) {
    const prefixes = [
      'Cover overview',
      'Coverage overview',
      'Coverage Overview',
      'Dekkingoverzicht',
      'Dekkingsoverzicht',
      'Policy conditions',
      'Polisvoorwaarden',
      'Terms and conditions',
      'Vergoedingenoverzicht',
      'Voorwaarden',
    ];
    let prefix = '';
    let packet = '';

    prefixes.forEach((p) => {
      if (name.includes(p)) {
        prefix = p;
        packet = name.replace(p, '').replace('.pdf', '').trim();
      }
    });

    return {
      prefix: prefix,
      packet: packet,
    };
  }
}
export { Message as default };
